var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFogetpassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 216,
    viewBox: "0 0 218 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 143.751,
    cy: 72.2512,
    r: 142.942,
    fill: "url(#paint0_linear_96_4802)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.9785 88.9086V68.4465C81.9785 67.7065 82.2725 66.9968 82.7958 66.4735C83.3191 65.9502 84.0288 65.6562 84.7688 65.6562H140.574C141.315 65.6562 142.024 65.9502 142.548 66.4735C143.071 66.9968 143.365 67.7065 143.365 68.4465V88.9086C143.365 118.212 118.494 127.92 113.528 129.567C112.973 129.758 112.37 129.758 111.815 129.567C106.849 127.92 81.9785 118.212 81.9785 88.9086Z",
    stroke: "white",
    strokeWidth: 5.58057,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.018 85.1885L107.556 104.72L97.3252 94.9545",
    stroke: "white",
    strokeWidth: 5.58057,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_96_4802",
    x1: -38.0861,
    y1: 336.33,
    x2: 467.985,
    y2: -91.9928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0260417,
    stopColor: "#FF8DB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FF3355"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFogetpassword);
export default __webpack_public_path__ + "static/media/Foget password.b7a2d6c4b6b2e9d0b94167098064a89b.svg";
export { ForwardRef as ReactComponent };